import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-c-chica-agregar-gasto",
  templateUrl: "./c-chica-agregar-gasto.component.html",
  styleUrls: ["./c-chica-agregar-gasto.component.scss"],
})
export class CChicaAgregarGastoComponent implements OnInit {
  constructor() {}

  optionsTipoOpe: Array<any> = [];

  ngOnInit() {
    this.optionsTipoOpe = [
      { value: "1", label: "Gasto" },
      { value: "2", label: "Tipo Operación 2" },
      { value: "3", label: "Tipo Operación 3" },
    ];
  }
}
